import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ThankYou = () => {
  return (
    <div>
      <Navbar />

      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <h1 className="text-3xl font-bold text-green-600 mb-4">Thank You!</h1>

        <p className="text-gray-700 mb-6">
          Your message has been received. Our team will contact you shortly.
        </p>

        <a
          href="/"
          className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700"
        >
          Back to Home
        </a>
      </div>

      <Footer />
    </div>
  );
};

export default ThankYou;
